/**
 * profileChangeEmitter — Global event system for profile data changes.
 *
 * When any profile data (intent, health, athlete) is updated,
 * emitters fire a "profile-changed" event so that all dependent systems
 * (programs, planning, obsolescence) can refresh their state.
 */

type ProfileChangeListener = () => void;

const listeners = new Set<ProfileChangeListener>();

/** Subscribe to profile change events. Returns an unsubscribe function. */
export function onProfileChange(listener: ProfileChangeListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Emit a profile change event. Call after any successful profile update. */
export function emitProfileChange(): void {
  console.debug("[profileChangeEmitter] profile changed — invalidating dependents");
  listeners.forEach((fn) => {
    try { fn(); } catch (e) { console.error("[profileChangeEmitter] listener error", e); }
  });
}
